import MultiSelectList from 'component/atom/forms/select/multi-select-list/MultiSelectList';
import Select from 'component/atom/forms/select/select/Select';
import React from 'react';
import styles from '../CaptureForm.module.scss';
import Toggle from 'component/atom/forms/toggle/Toggle';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Input from 'component/atom/forms/input/input/Input';
import Button from 'component/atom/forms/button/ButtonNew';

const EntireUserReply = ({ formik, data, isFetching }) => {
  const typeOptions = data?.data?.items?.map((item) => ({
    value: item.variableId,
    label: item.variableName,
  }));

  return (
    <div className={styles['entire-reply']}>
      <Select
        label='Capture Variables'
        placeholder='Select Variables'
        options={typeOptions}
        name='variableId'
        value={formik.values.variableId}
        onChange={formik.handleChange}
        error={formik.errors.variableId}
        touched={formik.touched.variableId}
        isLoading={isFetching}
      />
      <MultiSelectList
        label='Variable'
        placeholder='Select Variables'
        name='variable'
        // value={stringsToArray}
        // onChange={(e) => {
        //   const selected = e.target.value.join(',');
        //   formik.setFieldValue(
        //     `formDetails[${index}].typeSelection`,
        //     selected
        //   );
        // }}
        // onBlur={formik.handleBlur}
        options={[
          {
            label: 'start_date',
            value: 'start_date',
          },
          {
            label: 'end_date',
            value: 'end_date',
          },
        ]}
      />
      <div className={styles.suggest}>
        <p>Suggestions</p>
        <Toggle
          name='hasSuggestions'
          value={formik.values.hasSuggestions || false}
          onToggleChange={(e) => {
            formik.setFieldValue(
              `hasSuggestions`,
              !formik.values.hasSuggestions
            );
          }}
        />
      </div>
      <div className={styles.suggest}>
        <p>AI Generated Question</p>
        <Toggle
          name='hasAIGenerated'
          value={formik.values.hasAIGenerated || false}
          onToggleChange={(e) => {
            formik.setFieldValue(
              `hasAIGenerated`,
              !formik.values.hasAIGenerated
            );
          }}
        />
      </div>
      <>
        {' '}
        <div className={styles['label-container']}>
          <p className={styles['label']}>Predefined Suggestions</p>
          {formik.values.suggestedQuestions?.length < 4 && (
            <Button
              type='plus'
              transparent
              buttonType='button'
              onClick={() => {
                formik.setFieldValue('suggestedQuestions', [
                  ...(formik.values.suggestedQuestions || []),
                  '',
                ]);
              }}
              className={styles['button']}
            />
          )}
        </div>
        {formik.values.suggestedQuestions.map((variant, index) => (
          <div className={styles['multi-input']} key={index}>
            <Input
              name={`suggestedQuestions.${index}.question`}
              value={variant?.question}
              onChange={formik.handleChange}
              errors={formik.errors?.suggestedQuestions?.[index]?.question}
              touched={formik.touched?.suggestedQuestions?.[index]?.question}
              placeholder='Enter a question'
              maxLength='30'
            />
            <div className={styles['variant-action']}>
              <SvgWithBranding
                type='delete_table'
                className={styles.icon}
                onClick={() => {
                  const updatedVariants =
                    formik.values.suggestedQuestions.filter(
                      (_, i) => i !== index
                    );
                  formik.setFieldValue('suggestedQuestions', updatedVariants);
                }}
              />
            </div>
          </div>
        ))}
      </>
      <div className={styles.suggest}>
        <p>Reassess Intent</p>
        <Toggle
          name='reassessIntent'
          value={formik.values.reassessIntent || false}
          onToggleChange={(e) => {
            formik.setFieldValue(
              `reassessIntent`,
              !formik.values.reassessIntent
            );
          }}
        />
      </div>
    </div>
  );
};

export default EntireUserReply;
